// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../types';
import media from '../../../../../helpers/media';

type Props = {
  isOpen: boolean,
};

export default styled<any, Theme, Props>('div')`
  color: ${props => props.theme.configChoice.descriptionColor};
  display: ${props => (props.isOpen ? 'block' : 'none')};
  padding: .25rem .5rem 1rem;

  ${media.md(css`
    display: block;
  `)};
`;
